module.exports = __webpack_public_path__ + "static/img/right-banner-01.295959c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/main/right-banner-01.jpg
// module id = bzn+
// module chunks = 1